import { t } from 'ember-intl';
import TioLoadingSpinner from 'tio-common/components/tio/loading-spinner';

<template>
  {{! The only substate Ember can render while a top-level route (the shell included) resolves. }}
  <div class="min-h-screen tio-col-flush tio-bg-page" data-test-app-loading aria-busy="true">
    <header class="h-14 tio-bg-surface border-b tio-border-subtle"></header>
    <div class="flex-1 tio-row-center">
      <TioLoadingSpinner aria-label={{t "login.loading"}} />
    </div>
  </div>
</template>
